import { useFormContext } from "react-hook-form";
import { RadioGroup } from "@/src/components/Fields/RadioGroup";

import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";
import { USE_SELECT_FIELD_UPDATE_DELAY } from "@/src/shared/const/delay";

export function RadioButtons(props: any) {
  const { name } = props;
  const { control } = useFormContext();
  const debouncedUpdateField = useFieldDebouncedCallback(name, USE_SELECT_FIELD_UPDATE_DELAY);

  return (
    <RadioGroup
      {...props}
      name={name}
      control={control}
      onChange={(_, value) => debouncedUpdateField(value)}
    />
  );
}
